import { fromJS } from 'immutable';
import {
  SAVED_SEARCH_LOAD,
  DELETE_SEARCH_LOAD,
  UNSUBSCRIBE_SAVED_SEARCH,
  SUBSCRIBE_SAVED_SEARCH,
  LOAD_COUNT_ANNOUNCEMENT_BY_SAVED_SEARCH
} from './actionTypes';
import { getUser } from '../User/actions';
import { START, SUCCESS, ERROR } from '../../consts';
import api from '../../apiSingleton';

export function loadSavedSearch () {
  return (dispatch, getState) => {
    dispatch({
      type: SAVED_SEARCH_LOAD + START
    });

    const user = getState().get('user');

    return api.user
    .filters(user.getIn(['data', 'id']), user.get('token'))
    .then(data =>
      dispatch({
        type: SAVED_SEARCH_LOAD + SUCCESS,
        payload: fromJS(data)
      })
    ).catch(error => dispatch({
      type: SAVED_SEARCH_LOAD + ERROR,
      payload: error
    }));
  };
}

export function deleteSavedSearch (filterId) {
  return (dispatch, getState) => {
    dispatch({
      type: DELETE_SEARCH_LOAD + START
    });

    const user = getState().get('user');

    return api.user
    .deleteFilter(user.getIn(['data', 'id']), filterId, user.get('token'))
    .then(data => {
      dispatch({ type: DELETE_SEARCH_LOAD + SUCCESS });
      dispatch(getUser());
      return dispatch(loadSavedSearch());
    }).catch(error => dispatch({
      type: DELETE_SEARCH_LOAD + ERROR,
      payload: error
    }));
  };
}

export function subscribeSavedSearch (filterId) {
  return (dispatch, getState) => {
    dispatch({
      type: SUBSCRIBE_SAVED_SEARCH + START
    });

    const user = getState().get('user');

    return api.user
    .subscribeFilter(user.getIn(['data', 'id']), filterId, user.get('token'))
    .then(data => {
      return dispatch({ type: SUBSCRIBE_SAVED_SEARCH + SUCCESS, filterId });
    });
  };
}

export function unsubscribeSavedSearch (filterId) {
  return (dispatch, getState) => {
    dispatch({
      type: UNSUBSCRIBE_SAVED_SEARCH + START
    });

    const user = getState().get('user');

    return api.user
    .unsubscribeFilter(user.getIn(['data', 'id']), filterId, user.get('token'))
    .then(data => {
      return dispatch({ type: UNSUBSCRIBE_SAVED_SEARCH + SUCCESS, filterId });
    });
  };
}

export function getCountAnnouncementBySavedSearch (dealType, realtyType, filter) {
  return (dispatch) => {
    dispatch({
      type: LOAD_COUNT_ANNOUNCEMENT_BY_SAVED_SEARCH + START
    });

    return api.announcement
    .fetchCountAnnouncement(dealType, realtyType, filter)
    .then(data => {
      return dispatch({ type: LOAD_COUNT_ANNOUNCEMENT_BY_SAVED_SEARCH + SUCCESS, payload: data });
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/SavedSearch/actions.js